export default __webpack_public_path__ + "static/media/textoimpacto.7e7ff2fc.png";